import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Tag = styled.span.withConfig({
  displayName: "partials__Tag",
  componentId: "sc-jbvs3z-0"
})(["", ";display:inline-flex;border:1px solid ", ";border-radius:", ";color:", ";", ";"], getFont(-1), function (_ref) {
  var theme = _ref.theme,
    trend = _ref.trend;
  return !trend ? 'currentColor' : trend === 'bull' ? theme.colors.positive : theme.colors.negative;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme,
    trend = _ref3.trend;
  return !trend ? theme.colors.uiD : trend === 'bull' ? theme.colors.positive : theme.colors.negative;
}, function (_ref4) {
  var theme = _ref4.theme,
    trend = _ref4.trend;
  return !trend ? "background-color:".concat(theme.colors.ui, ";") : '';
});
export var Label = styled.span.withConfig({
  displayName: "partials__Label",
  componentId: "sc-jbvs3z-1"
})(["padding:1.5px 6px;background-color:", ";font-weight:600;color:#fff;"], function (_ref5) {
  var theme = _ref5.theme,
    trend = _ref5.trend;
  return !trend ? theme.colors.uiD : trend === 'bull' ? theme.colors.positive : theme.colors.negative;
});
export var Value = styled.span.withConfig({
  displayName: "partials__Value",
  componentId: "sc-jbvs3z-2"
})(["padding:1.5px 6px;border-radius:0 ", " ", " 0;font-weight:500;color:", ";", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius;
}, function (_ref8) {
  var theme = _ref8.theme,
    trend = _ref8.trend;
  return !trend ? 'currentColor' : trend === 'bull' ? theme.colors.positive : theme.colors.negative;
}, function (_ref9) {
  var trend = _ref9.trend;
  return !trend ? "background-color: #fff;" : '';
});